export default "__VITE_ASSET__O5y1UBZW__"